import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import moment from "moment";
import { ModalHeader, ScrollableContent } from "../../Styles/InputStyles";
import { capitalizeFirstLetter } from "../../../helpers";
import { Form, } from "formik";
import { ownership_roles } from "../../../Config";

const LandlordLeaseViewModal = ({
    setViewDetails,
    selectedData,
}) => {

    const onClose = () => {
        setViewDetails(false);
    };

    const getRentCollectionTypeText = (collectionType) => {
        switch (collectionType) {
            case 1: return "Advance Rent";
            case 2: return "Month-End Rent";
            default: return "--";
        }
    };
    const getFlatOrPropertyInfo = () => {
        return `${selectedData.flatName}, ${selectedData.propertyAddress || selectedData.propertyName}`;
    };
    const formatDate = (date) => {
        if (!date) return "-";
        return moment(date).format("DD, MMM YY");
    };
    const formatCurrency = (val) => {
        if (!val && val !== 0) return "-";
        return `₹${Number(val).toLocaleString("en-IN")}`;
    }
    return (
        <>
            <Container>
                <ModalHeader>
                    <Title>Lease Details</Title>
                    <button onClick={onClose}>
                        <MdClose color="white" size={24} />
                    </button>
                </ModalHeader>

                <ProfileSection className="flex justify-between">
                    <UserInfo>
                        <span className="font-medium mb-0 text-gray-800">
                            {capitalizeFirstLetter(selectedData?.landlordName)}
                        </span>
                        <span className="text-sm text-gray-600">
                            {getFlatOrPropertyInfo()}
                        </span>
                    </UserInfo>
                    <div className="flex flex-col gap-0 text-right">
                        <span className='text-gray-500 text-sm'>Monthly Rent</span>
                        <span className='text-xl font-semibold text-gray-700'>{formatCurrency(selectedData?.rent)}</span>
                    </div>
                </ProfileSection>

                <Content>
                    <ScrollableContent>
                        <Wrapper>
                            <BtnWrapper>
                                <SectionTitle>Landlord Information</SectionTitle>
                            </BtnWrapper>

                            <Section>
                                <Row className="mb-3">
                                    <FlexCol>
                                        <Label>Ownership</Label>
                                        <Value> {ownership_roles.find(r => r.value === selectedData?.ownershipType)?.label || "--"}</Value>
                                    </FlexCol>
                                    <FlexCol>
                                        <Label>Email</Label>
                                        <Value className="truncate block">{selectedData?.landlordEmail || "--"}</Value>
                                    </FlexCol>

                                </Row>

                                <Row className="mb-3">
                                    <FlexCol>
                                        <Label>Mobile Number</Label>
                                        <Value>{selectedData?.landlordMobile || "--"}</Value>
                                    </FlexCol>
                                    <FlexCol>
                                        <Label>Alternate Mobile</Label>
                                        <Value>{selectedData?.landlordAltMobile || "--"}</Value>
                                    </FlexCol>
                                </Row>

                            </Section>

                            <BtnWrapper>
                                <SectionTitle>Lease Information</SectionTitle>
                            </BtnWrapper>

                            <Section>
                                <Row className="mb-3">
                                    <FlexCol>
                                        <Label>Security Deposit</Label>
                                        <Value>{formatCurrency(selectedData?.security)}</Value>
                                    </FlexCol>
                                    <FlexCol>
                                        <Label>Rent Collection Type</Label>
                                        <Value>{getRentCollectionTypeText(selectedData?.rentCollectionType)}</Value>
                                    </FlexCol>
                                </Row>
                                <Row className="mb-3">

                                    <FlexCol>
                                        <Label>Lease Period</Label>
                                        <Value>
                                            {formatDate(selectedData?.startDate)} - {formatDate(selectedData?.endDate)}
                                        </Value>
                                    </FlexCol>
                                    <FlexCol>
                                        <Label>Rent Due Date</Label>
                                        <Value>
                                            {formatDate(selectedData.rentDate)}
                                        </Value>
                                    </FlexCol>
                                </Row>
                                <Row className="mb-3">

                                    <FlexCol>
                                        <Label>Lock-in Period</Label>
                                        <Value>{selectedData?.lockInPeriod || 0} months</Value>
                                    </FlexCol>
                                    <FlexCol>
                                        <Label>Notice Period</Label>
                                        <Value>{selectedData?.notice || 0} months</Value>
                                    </FlexCol>
                                </Row>

                                <Row className="mb-3">
                                    <FlexCol>
                                        <Label>Increment Frequency</Label>
                                        <Value>
                                            {selectedData?.incrementMonth
                                                ? `Every ${selectedData.incrementMonth} month(s)`
                                                : "-"}
                                        </Value>
                                    </FlexCol>
                                    <FlexCol>
                                        <Label>Increment Value</Label>
                                        <Value>
                                            {selectedData?.incrementValue
                                                ? selectedData?.incrementType === 2
                                                    ? `${selectedData.incrementValue}%`
                                                    : `₹${selectedData.incrementValue}`
                                                : "-"}
                                        </Value>
                                    </FlexCol>
                                </Row>

                            </Section>

                        </Wrapper>
                    </ScrollableContent>
                </Content>
            </Container>

        </>
    );
};


// Styled components for the modal

const Wrapper = tw.div`grid gap-2 my-0`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const Content = tw.div`p-4 flex flex-col gap-4`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-white`;
const Section = tw.div`border border-gray-200 p-2 rounded-lg mb-3`;
const SectionTitle = tw.h2`text-base font-medium text-gray-600 flex justify-between items-center`;
const Row = tw.div`grid grid-cols-2 py-1 md:p-1`;
const Label = tw.label`text-sm text-gray-400 font-normal`;
const Value = tw.span`text-gray-600 text-md`;
const BtnWrapper = tw.div`w-full flex items-center justify-between`;
// const FlexCol = tw.div`flex flex-col gap-0.5`;
const FlexCol = tw.div`flex flex-col gap-0.5 min-w-0`;
const UserInfo = tw.div`flex flex-col`;
const ProfileSection = tw.div`flex items-center gap-3 bg-gray-100 px-4 p-4`;

export default LandlordLeaseViewModal;